// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ../common/buttons.scss
 ** module id = 611
 ** module chunks = 9
 **/